module.exports = __webpack_public_path__ + "img/tvbet.2dea9d9d.jpg";